"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentPrefix = void 0;
/**
 * Get the prefix for environment.
 *
 * @public
 *
 * @example
 * ```ts
 * const url = geoLocationURI(EnvironmentPrefix.STG);
 * console.log(url); // https://geolocation.stg.healthcare.com
 * ```
 */
var EnvironmentPrefix;
(function (EnvironmentPrefix) {
    EnvironmentPrefix["QA"] = "qa.";
    EnvironmentPrefix["STG"] = "stg.";
    EnvironmentPrefix["LOCAL"] = "qa.";
    EnvironmentPrefix["LOCALHOST"] = "qa.";
    EnvironmentPrefix["PRD"] = "";
})(EnvironmentPrefix || (EnvironmentPrefix = {}));
exports.EnvironmentPrefix = EnvironmentPrefix;
//# sourceMappingURL=environments-prefix.js.map